import { Hidden } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GuidedProcessSupportBlock } from '../../../global/components/guided-process-support-block';
import { DividerSection } from '../../../global/components/layout/divider-section';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { PageHeader } from '../../../global/components/layout/page-header';
import { SideBarContent } from '../../../global/components/layout/sidebar-content';
import { WysiwygWithReactLink } from '../../../global/components/wysiwyg-with-react-link';
import { getPodsContent } from '../../../global/ducks/epi-api';
import { YesNoIndicators } from '../../../global/models/api-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { DentalData, MedicalData, MyCpgPodsSettings, PodContent } from '../mycpg-pod-models';

interface Props {
	settings: MyCpgPodsSettings;
}
export function HealthPlanDetail(props: Props) {

	const { settings } = props;
	const medicalPlan = useSelector<TcsmStates, MedicalData>(state => state?.mycpgPodsState?.pods?.medical_data);
	const dentalPlan = useSelector<TcsmStates, DentalData>(state => state?.mycpgPodsState?.pods?.dental_data);
	const [content, setContent] = useState<any>({});
	const dispatch = useDispatch();
	const contentTemp = {};
	const noEnrolled = medicalPlan?.content === PodContent.NOT_ENROLLED && dentalPlan?.content === PodContent.NOT_ENROLLED;
	const onContentSuccess = (key, html) => {
		contentTemp[key] = html;
		setContent({ ...contentTemp });
	};

	useEffect(() => {
		if (medicalPlan?.data?.content_path) {
			dispatch(getPodsContent(medicalPlan?.data?.content_path, (data) => onContentSuccess(medicalPlan?.data?.content_path, data?.contentHtml)));
		}

		if (dentalPlan?.data?.content_path) {
			dispatch(getPodsContent(dentalPlan?.data?.content_path, (data) => onContentSuccess(dentalPlan?.data?.content_path, data?.contentHtml)));
		}
	}, []);

	function RenderNoBeneficiaries(){
		if (settings?.noDependantsLabel){
			return (
				<ContentSpacer>
					<p className='h3-styled'>{settings?.dependentsLabel}</p>					
					<p>{settings?.noDependantsLabel}</p>					
				</ContentSpacer>
			);
		}
	}

	function RenderMedicalBeneficiaries(){
		if (medicalPlan?.content === PodContent.NOT_ENROLLED) return null;

		if (medicalPlan?.show_beneficiaries === YesNoIndicators.Yes && medicalPlan?.data.beneficiaries?.length > 0) {
			return (
				<ContentSpacer>
					<p className='h3-styled'>{settings?.dependentsLabel}</p>
					{
						medicalPlan?.data.beneficiaries?.map(b => <p>{b}</p>)
					}
				</ContentSpacer>
			);
		}

		return RenderNoBeneficiaries();
	}

	function RenderDentalBeneficiaries(){
		if (dentalPlan?.content === PodContent.NOT_ENROLLED) return null;

		if (dentalPlan?.show_beneficiaries === YesNoIndicators.Yes && dentalPlan?.data.beneficiaries?.length > 0) {
			return (
				<ContentSpacer>
					<p className='h3-styled'>{settings?.dependentsLabel}</p>
					{
						dentalPlan?.data.beneficiaries?.map(b => <p>{b}</p>)
					}
				</ContentSpacer>
			);
		}

		return RenderNoBeneficiaries();
	}

	function RenderDetailSection(){
		return (
			<>
				<DividerSection sectionText={settings?.medicalLabel}>
					<ContentSpacer>
						<WysiwygWithReactLink content={medicalPlan?.content === PodContent.NOT_ENROLLED ? settings?.medicalNotEnrolledText : medicalPlan?.data?.description} />
					</ContentSpacer>
					{ RenderMedicalBeneficiaries() }
					<WysiwygWithReactLink content={content[medicalPlan?.data?.content_path]} />
				</DividerSection>

				<DividerSection sectionText={settings?.dentalLabel}>
					<ContentSpacer>
						<WysiwygWithReactLink content={dentalPlan?.content === PodContent.NOT_ENROLLED ? settings?.dentalNotEnrolledText : dentalPlan?.data?.description} />						
					</ContentSpacer>
					{ RenderDentalBeneficiaries() }
					<WysiwygWithReactLink content={content[dentalPlan?.data?.content_path]} />
				</DividerSection>
				<DividerSection >
					<WysiwygWithReactLink content={settings?.healthDetailDescription} />
				</DividerSection>
			</>
		);
	}

	return (
		<>
			<PageHeader headerText={settings?.healthPlanDetailTitle} />
			<Hidden mdUp>
				<SideBarContent>
					<GuidedProcessSupportBlock title={settings?.healthGpsTitle} contents={settings?.healthGps} />
				</SideBarContent>
			</Hidden>
			{
				noEnrolled ?
					<DividerSection removeDivider>
						<WysiwygWithReactLink content={settings?.healthPlanNotEnrolledMessage} />
					</DividerSection> :
					RenderDetailSection()
			}
		</>
	);
}
